import { componentClasses, defaultProps } from "../../../core/components/dropdown/dropdown";

const generateData = (id, groups, items, inactiveIndex) => {
    if (groups) {
        return Array(groups)
            .fill()
            .map((group, groupIndex) => {
                return {
                    id: `${id}-group-${groupIndex + 1}`,
                    title: `Grouped list title ${groupIndex + 1}`,
                    items: Array(items)
                        .fill()
                        .map((item, itemIndex) => {
                            return {
                                label: `Grouped list option ${groupIndex + 1}-${itemIndex + 1}`,
                                dataValue: `${groupIndex + 1}-${itemIndex + 1}`,
                                disabled: itemIndex === inactiveIndex,
                            };
                        }),
                };
            });
    }
    return Array(items)
        .fill()
        .map((item, itemIndex) => {
            return {
                label: `List option ${itemIndex + 1}`,
                dataValue: `${itemIndex + 1}`,
                disabled: itemIndex === inactiveIndex,
            };
        });
};

/**
 * Component DropdownTemmplate
 * @param {object} args - storybook arguments
 * @returns {string} - template string for drawer
 */
const DropdownTemplate = (args, id, groupNumber, itemNumber, inactiveIndex) => {
    const noOptionsLabelData =
        args.noOptionsLabel !== defaultProps.noOptionsLabel
            ? `data-no-options-label="${args.noOptionsLabel}"`
            : "";

    const selectedLabelData =
        args.selectedLabel !== defaultProps.selectedLabel
            ? `data-selected-label="${args.selectedLabel}"`
            : "";

    const srClearLabelData =
        args.srClearLabel !== defaultProps.srClearLabel
            ? `data-sr-clear-label="${args.srClearLabel}"`
            : "";

    const selectAllOptions = !args.selectAll ? `data-select-all="${args.selectAll}"` : "";
    const selectAllLabel = args.selectAllLabel
        ? `data-select-all-label="${args.selectAllLabel}"`
        : "";

    const dropdownClasses = [
        componentClasses.base,
        ...(args.size !== "lg" ? [componentClasses.sizes.sm] : []),
    ].join(" ");

    return `
<div
class="${dropdownClasses}"
data-dds="dropdown"
id="${id}"
data-selection="${args.selection}"
${noOptionsLabelData}
${selectedLabelData}
${srClearLabelData}
${selectAllOptions}
${selectAllLabel}
>
    <div class="${componentClasses.inputContainer}">
        <label id="${id}-label" for="${id}-input">Label</label>
        <div class="${componentClasses.inputWrapper}" 
            autocomplete="off"
            role="combobox" 
            aria-haspopup="listbox" 
            aria-controls="${id}-popup"
            aria-expanded="false">
            <input 
                id="${id}-input" 
                name="${id}-name" 
                type="text"
                class="${componentClasses.inputField}"
                aria-labelledby="${id}-label ${id}-helper"
                autocomplete="off"
                aria-expanded="false"
                aria-controls="${id}-list" />
            <small id="${id}-helper" class="dds__input-text__helper">Helper text</small>
            <div id="${id}-feedback" class="dds__invalid-feedback"></div>
        </div>
    </div>
    <div 
        id="${id}-popup" 
        class="${componentClasses.popup.base} ${componentClasses.popup.hidden}" 
        role="presentation"
        tabIndex="-1">
        <ul class="${componentClasses.list.base}" role="listbox" tabindex="-1" id="${id}-list">
        ${generateData(id, groupNumber, itemNumber, inactiveIndex)
            .map((item) => {
                if (item.items) {
                    return DropdownGroupTemplate(item.id, item.title, item.items);
                }
                return DropdownItemTemplate({
                    label: item.label,
                    dataValue: item.dataValue,
                    disabled: item.disabled,
                });
            })
            .join(" ")}
        </ul>
    </div>
</div>
    `;
};

const DropdownGroupTemplate = (id, title, items) => {
    return `
<li role="presentation">
    <span id="${id}" class="${componentClasses.groupTitle}">${title}</span>
    <ul class="${componentClasses.group}" role="group" aria-labelledby="${id}">
     ${items
         .map((item) => {
             return DropdownItemTemplate({
                 label: item.label,
                 dataValue: item.dataValue,
                 disabled: item.disabled,
             });
         })
         .join(" ")}
    </ul>
</li>
    `;
};
const DropdownItemTemplate = ({
    label,
    dataValue,
    disabled,
    selectAll = false,
    selectAllLabel = defaultProps.selectAllLabel,
}) => {
    const dataValueAttribute = dataValue ? `data-value="${dataValue}"` : "";
    const disabledAttribute = disabled ? `aria-disabled="true"` : "";
    const itemClasses = [componentClasses.item, selectAll ? componentClasses.selectAll : ""]
        .filter(Boolean)
        .join(" ");
    return `<li class="${itemClasses}" role="none">
    <button type="button" class="${
        componentClasses.itemOption
    }" ${disabledAttribute} role="option" data-selected="false" ${dataValueAttribute} tabindex="-1">
        <span class="${componentClasses.itemLabel}">${selectAll ? selectAllLabel : label}</span>
    </button>
</li>`;
};

const DropdownSeparatorTemplate = () => {
    return `<li role="separator" class="${componentClasses.listItemSeparator}">
    
</li>`;
};
export { DropdownTemplate, DropdownItemTemplate, DropdownSeparatorTemplate };
